(() => {
  document.querySelectorAll('[data-merged-product-reviews]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const cards = [...section.querySelectorAll('[data-customer-review]')];
    const search = section.querySelector('input[type="search"]');
    const footer = section.querySelector('.puz-rv__footer');
    const count = section.querySelector('.puz-rv__visible-count');
    const toggle = section.querySelector('.puz-rv__expand');
    const toggleLabel = toggle.querySelector('[data-review-toggle-label]') || toggle;
    const noResults = section.querySelector('.puz-rv__no-results');
    let expanded = false;
    const mobile = window.matchMedia('(max-width:600px)');
    section.querySelector('.puz-rv__search').hidden = false;
    footer.hidden = false;
    const update = () => {
      const query = search.value.trim().toLowerCase();
      const matching = cards.filter(card => card.textContent.toLowerCase().includes(query));
      const limit = query || expanded ? matching.length : mobile.matches ? 3 : 6;
      cards.forEach(card => { card.hidden = !matching.slice(0, limit).includes(card); });
      const shown = Math.min(limit, matching.length);
      count.textContent = `Showing ${shown} of ${matching.length} reviews`;
      noResults.hidden = matching.length > 0;
      toggle.hidden = !!query || matching.length <= (mobile.matches ? 3 : 6);
      toggle.setAttribute('aria-expanded', String(expanded));
      toggleLabel.textContent = expanded ? 'Show fewer reviews' : `Read all ${cards.length} reviews`;
    };
    toggle.addEventListener('click', () => { expanded = !expanded; update(); });
    search.addEventListener('input', update);
    mobile.addEventListener('change', update);
    update();
  });
})();
